import * as CryptoJS from 'crypto-js';
let cv = '';

// SECURITY (AppSec Finding #2 assurance work, 2026-09-29): the PKCE code_verifier only needs
// to survive the single redirect round-trip to Azure AD and back within THIS browser tab
// (generated here, sent as the code_challenge on the way out, sent again as-is in the token
// exchange body on the way back). It has no legitimate reason to outlive that - sessionStorage
// (tab-scoped, cleared on tab close) instead of localStorage (persists indefinitely, shared
// across tabs/restarts) reduces how long/where a captured verifier would remain usable.
const CODE_VERIFIER_STORAGE_KEY = 'code_verifier';

export function generateRandomString(length: number): string {
  let text = '';
  const codeVerifier = sessionStorage.getItem(CODE_VERIFIER_STORAGE_KEY);
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    // SECURITY: Use crypto.getRandomValues() for cryptographically secure randomness (128 bits)
    // PKCE code verifier must be 128 characters of unreserved characters: [A-Z] [a-z] [0-9] - . _ ~
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    const randomArray = new Uint8Array(length);
    crypto.getRandomValues(randomArray);

    for (let i = 0; i < length; i++) {
      text += possible.charAt(randomArray[i] % possible.length);
    }
    cv = text;
    sessionStorage.setItem(CODE_VERIFIER_STORAGE_KEY, cv);
    return text;
  }
}

export function generateCodeChallenge(codeVerifier: any): string {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallange + '&code_challenge_method=S256';
}

export function base64URL(string: any): string {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

// SECURITY (AppSec Finding #2 assurance work): call once the authorization code has been
// successfully exchanged, OR the OAuth flow came back with `error` (user cancelled/denied
// consent) - either way this verifier's job is done and it must not be reused for the NEXT
// login attempt. (Genuine token-exchange failures already go through a full
// sessionStorage.clear()/localStorage.clear() recovery path elsewhere - see app.component.ts -
// which removes it too, so this only needs to be called explicitly for the two paths above.)
export function clearCodeVerifier(): void {
  sessionStorage.removeItem(CODE_VERIFIER_STORAGE_KEY);
}

export const logindetails = {
  codeVerifier: generateRandomString(128),
  codeChallenge: generateCodeChallenge(cv)
};